const strings = {
  // API_ROUTE: "http://localhost:8080/",
  API_ROUTE: "https://buildtectapi.devminds.co.in/",
};
export default strings;
